// Unico file da aggiornare per i recapiti del sito.
export const CONTACT_EMAIL = 'info@3lune.tech';

export const trackMetaLead = () => {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'Lead');
  }
};
